import { Box, Card, Grid, GridBreak, RichTextReader, Stack, Typography } from "@compass/core";
import { SubmitButton } from "components";
import { Application } from "generated/openApi";
import { useEffect } from "react";

type publicApplicationTitleProps = {
  application: Application;
  beginApplication: () => void;

  navigateChildApplication: () => void;
  navigateParentApplication: () => void;
};

export const PublicApplicationTitle = ({
  application,
  beginApplication,
  navigateChildApplication,
  navigateParentApplication,
}: publicApplicationTitleProps) => {
  useEffect(() => {}, []);

  return (
    <Card
      sx={{ maxWidth: "1000px", width: "100%" }}
      header={
        <Stack direction="row" justifyContent="flex-end">
          <Stack direction="row" alignItems="center" spacing="sm">
            {application.childApplications && application.childApplications!.length > 0 && (
              <SubmitButton
                label={application.languageId == 2 ? "English" : "En Español"}
                onClick={() => navigateChildApplication()}
              />
            )}
            {application.parentApplicationId && (
              <SubmitButton
                label={application.languageId == 2 ? "English" : "En Español"}
                onClick={() => navigateParentApplication()}
              />
            )}
          </Stack>
        </Stack>
      }
    >
      <Stack px={3} py={7} spacing="lg" width="100%">
        <Grid container spacing="sm">
          <Grid item xs={12}>
            <Typography variant="h4" textAlign="center">
              {application.title}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" textAlign="center">
              {application.subTitle}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <RichTextReader html={application.instruction} />
          </Grid>

          <GridBreak />

          <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ paddingTop: 5 }}>
              <SubmitButton
                label={application.languageId == 2 ? "Comienza" : "Begin Application"}
                onClick={() => beginApplication()}
              />
            </Box>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
